module.exports = __webpack_public_path__ + "img/help-feature-nav.b6153281.png";